// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3jMJ0","comment":"styles_comment__5d2rp"};